
import { conformToMask } from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
 
export const dollarAmountNumberMask = createNumberMask({
  prefix: '$',
  suffix: '',
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2,
  allowNegative: false,
  allowLeadingZeroes: false,
});

export const parseInputValue = (valueProp) => {
  const conformedPhoneNumber = conformToMask(
    valueProp === 0 ? '' : valueProp?.toString() || '',
    dollarAmountNumberMask,
    { guide: false }
  );
  const newValue = conformedPhoneNumber.conformedValue;
  return newValue;
};
export const parseStrInputValue = (valueProp) => {
  const conformedPhoneNumber = conformToMask(
    valueProp || '',
    dollarAmountNumberMask,
    { guide: false }
  );
  const newValue = conformedPhoneNumber.conformedValue;
  return newValue;
};

export const parseOutputValue = (value) => {
  return parseFloat((+(value?.replaceAll('_', '')?.replaceAll('$', '')?.replaceAll(',', '') ?? '')).toFixed(2));
};

